import React, { useEffect, useRef, useState } from "react";
import { createUrl, post } from "../../network/AxiosInterceptor";

import { ExploreTripsView } from "./ExploreTripsView";
import {
  containsMonth,
  getCurrentAndNextThreeMonths,
  getAllMonths,
} from "../../utils/DateUtils";

const ExploreTrips = () => {
  const trips = useRef([]);
  const [showLoader, setShowLoader] = useState(true);

  const [firstMonthList, setFirstMonthList] = useState([]);
  const [secondMonthList, setSecondMonthList] = useState([]);
  const [thirdMonthList, setThirdMonthList] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [monthlyTrips, setMonthlyTrips] = useState({});

  const months = getAllMonths();

  const monthOptionsArr = [{ label: "All", value: "All" }];

  useEffect(() => {
    const fetchAllTrips = async () => {
      const monthSet = new Set();
      post(createUrl(`/api/trips/listing`), {})
        .then((response) => {
          trips.current = response.data.trips;
          response.data.trips.forEach((tr) => {
            tr.tripDates.forEach((dt) => {
              dt.tripTitleLine = dt.tripTitleLine?dt.tripTitleLine : "";
              monthSet.add(String(dt.from).slice(4, 7));
              setMonthlyTrips((prev) => {
                const month_string = String(dt.from).slice(4, 7);
                if (prev[month_string] && prev[month_string].length > 0) {
                  if (
                    !prev[month_string].includes(tr) &&
                    dt.from.getTime() > new Date().getTime()
                  ) {
                    prev[month_string].push(tr);
                    tr[`${month_string}`] = `${dt?.tripTitleLine}`
                    // tr[`${month_string}`] = `${dt.from
                    //   .toGMTString()
                    //   .substr(4, 7)
                    //   .trim()} - ${dt.to.toGMTString().substr(4, 7).trim()}`;
                  }
                } else {
                  if (dt.from.getTime() > new Date().getTime()) {
                    prev[month_string] = [tr];
                    tr[`${month_string}`] = `${dt?.tripTitleLine}`
                    // tr[`${month_string}`] = `${dt.from
                    //   .toGMTString()
                    //   .substr(4, 7)
                    //   .trim()} - ${dt.to.toGMTString().substr(4, 7).trim()}`;
                  }
                }
                return prev;
              });
            });
          });
          months.forEach((m, index) => {
            if (monthSet.has(m.month.slice(0, 3))) {
              monthOptionsArr.push({ label: m.formattedMonth, value: m.month });
            }
            if (index == 11) setShowLoader(false);
          });
        })
        .catch(function (error) {
          console.log(error);
          setShowLoader(false);
        });
    };

    fetchAllTrips();
  }, []);

  useEffect(() => {
    const updateList = () => {
      setFirstMonthList(() => {
        return trips.current
          .filter(
            (tr) =>
              selectedCategory === "" ||
              selectedCategory === "All" ||
              tr.tripCategory.includes(selectedCategory)
          )
          .filter((tr) => containsMonth(tr.tripDates, months[0].month));
      });
      setSecondMonthList(() => {
        return trips.current
          .filter(
            (tr) =>
              selectedCategory === "" ||
              selectedCategory === "All" ||
              tr.tripCategory.includes(selectedCategory)
          )
          .filter((tr) => containsMonth(tr.tripDates, months[1].month));
      });
      setThirdMonthList(() => {
        return trips.current
          .filter(
            (tr) =>
              selectedCategory === "" ||
              selectedCategory === "All" ||
              tr.tripCategory.includes(selectedCategory)
          )
          .filter((tr) => containsMonth(tr.tripDates, months[2].month));
      });
    };

    updateList();
  }, [selectedCategory, showLoader]);

  const tripMonthHandler = (month) => {
    setSelectedMonth(month);
    setTimeout(() => setSelectedMonth(""), 500);
  };

  const tripDataHandler = (tripCategory) => {
    setSelectedCategory(tripCategory);
  };

  return (
    <div>
      <ExploreTripsView
        showLoader={showLoader}
        tripMonthHandler={tripMonthHandler}
        monthOptionsArr={monthOptionsArr}
        tripDataHandler={tripDataHandler}
        selectedMonth={selectedMonth}
        firstTripList={firstMonthList}
        secondTripList={secondMonthList}
        thirdTripList={thirdMonthList}
        firstMonthName={months[0].month}
        secondMonthName={months[1].month}
        thirdMonthName={months[2].month}
        months={months}
        monthlyTrips={monthlyTrips}
        selectedCategory={selectedCategory}
      />
    </div>
  );
};

export default ExploreTrips;
